import { useState } from 'react';
import { NavIcon } from './nav';

export function Avatar({ url, size = 32 }: { url?: string | null | undefined; size?: number }) {
  const [failed, setFailed] = useState<string | null>(null);
  return (
    <span
      style={{ width: size, height: size }}
      className="inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-chip text-inkFaint"
    >
      {url && failed !== url ? (
        <img
          src={url}
          alt=""
          width={size}
          height={size}
          className="h-full w-full object-cover"
          onError={() => setFailed(url)}
        />
      ) : (
        <NavIcon name="account" size={Math.round(size / 2)} />
      )}
    </span>
  );
}
